import { AfterViewInit, Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[kbStickyAnchorContainer]',
    standalone: true,
})
export class StickyAnchorContainerDirective implements AfterViewInit {
    constructor(private viewContainerRef: ViewContainerRef) {}

    get element(): HTMLElement {
        return this.viewContainerRef.element.nativeElement;
    }

    ngAfterViewInit() {
        this.element.classList.add('relative');
    }
}
